module.exports = __webpack_public_path__ + "img/curve_3@2x.c7da35dc.png";